






















































































import { Component, Mixins } from 'vue-property-decorator';

import HeaderComponent from '@/ui-components/header/HeaderComponent.vue';
import FooterComponent from '@/ui-components/footer/FooterComponent';
import commonEntry from '@/store/modules/commonEntry';
import { ScreenText } from '@/lang/ScreenText';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import DashboardLeftPanel from '../dashboardContainer/dashboardLeftPanel/DashboardLeftPanel.vue';
import APP_UTILITIES from '@/utilities/commonFunctions';
import BouncingPreloader from '@/commoncomponents/bouncingpreloadercomponent/BouncingPreloaderComponent.vue';
import catalogStore from '@/store/modules/catalog/module';
import CatalogFilters from './catalogContent/catalogFilters/CatalogFilters.vue';
import CatalogSessionList from './catalogContent/sessions/CatalogSessionList.vue';
import EmptyStateCard from './catalogContent/EmptyStateCard.vue';
import CatalogIcon from '@/components/icons/catalog-icon.vue';
import ResultIcon from '@/components/icons/result-icon.vue';
import AccountSettings from '@/mixins/accountSettings.mixin';

@Component({
  components: {
    BouncingPreloader,
    HeaderComponent,
    FooterComponent,
    DashboardLeftPanel,
    CatalogFilters,
    CatalogSessionList,
    EmptyStateCard,
    CatalogIcon,
    ResultIcon,
  }
})
export default class CatalogContainer extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public headerOffcanvasVisible = false;
  private screenText = new ScreenText();

  get userLoggedIn(): boolean {
    return !!APP_UTILITIES.getCookie('authorization_token');
  }

  get isLoadingAccountDetails(): boolean {
    return commonEntry.accountDesignDetails.accountId === undefined;
  }

  get isLoadingFilters(): boolean {
    return catalogStore.isLoadingFilters;
  }

  get showAccountSessions(): boolean {
    return catalogStore.isInitialLoadingSessions || catalogStore.didSessionFetchFail || catalogStore.totalSetCount > 0;
  }

  get designColor(): string {
    return commonEntry.accountDesignDetails.accentColor;
  }

  get headingText(): string {
    return this.screenText.getScreenText('CATALOG_HEADING');
  }

  get filterMenuHeadingText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_MENU_HEADING');
  }

  get filterMenuResultsText(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_MENU_SHOW_RESULTS');
  }

  get emptyHeadingText(): string {
    return this.screenText.getScreenText('CATALOG_EMPTY_HEADING');
  }

  get emptyMessageText(): string {
    return this.screenText.getScreenText('CATALOG_EMPTY_MESSAGE');
  }

  async beforeMount() {
    catalogStore.RESET_CATALOG_STORE();
    catalogStore.retrieveSessionFilters(commonEntry.accountDesignDetails.accountId);
  }
}
